module.exports = __webpack_public_path__ + "static/img/jljcxxy_tittle.dc845d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jljcxxy_tittle.png
// module id = G3ta
// module chunks = 167